import axios from 'axios';

import settings from '../libs/config';
import Logger from '../functions/logging';
import ApiError from './apiError.js';

const endpoint = settings.portal_player_base + "/php/Auth.php";

export const setPlayerSessionUserId = async (user) => {
	Logger.log(this.constructor.name, "setPlayerSessionUserId()", user);
	if (!user) {
		throw new Error("Missing user");
	}
	let userId = null;
	if (user.user_id) {
		userId = user.user_id;
	}
	if (!userId) {
		throw new Error("Missing user_id");
	}

	var form = new FormData();
	form.append('action', "set_user_id");
	form.append('userId', userId);

	try {
		// const response = axios.post(endpoint, {
		// 	params: {
		// 		userId: userId,
		// 		action: "set_user_id"
		// 	}
		// });

		// const response = axios.post(endpoint, {
		// 	form
		// });

		const response = await axios({
			method: 'post',
			url: endpoint,
			data: form,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		Logger.log(this.constructor.name, "setPlayerSessionUserId() response", response);
		
		return response;
	} catch (error) {
		throw new ApiError(error);
	}
};

export const setPlayerSessionQuotaMethods = async (quotaMethodData) => {
	Logger.log(this.constructor.name, "setPlayerSessionQuotaMethods()", quotaMethodData);
	if (!quotaMethodData) {
		throw new Error("Missing quotaMethodData");
	}

	var form = new FormData();
	form.append('action', "quota_method_update");
	form.append('methods', JSON.stringify(quotaMethodData));

	try {
		const response = await axios({
			method: 'post',
			url: endpoint,
			data: form,
			config: { headers: { 'Content-Type': 'multipart/form-data' } }
		});

		Logger.log(this.constructor.name, "setPlayerSessionQuotaMethods() response", response);

		return response;
	} catch (error) {
		throw new ApiError(error);
	}
};



// WEBPACK FOOTER //
// ./src/api/player.js